import React from "react";
import { Button, ButtonGroup, Tooltip } from "@mui/material";
import { CheckCircle, Cancel, MailOutline, LockOpen, Lock } from "@mui/icons-material";

const ActivationStatusCell = ({ user, onAction }) => {
  const handleAction = (action) => {
    if (onAction) onAction(user, action);
  };

  const getPendingTooltip = () => {
    if (!user.regdate) return "Registration date not available";
    const regDate = new Date(user.regdate);
    return `Registered on ${regDate.toLocaleString()}`;
  };

  if (!user.email_verified_at) {
    return (
      <Tooltip title="User hasn't verified their email yet">
        <div style={{width: "150px"}}>
        <Button
          variant="outlined"
          color="warning"
          onClick={() => handleAction("resend_verification")}
          startIcon={<MailOutline />}
          fullWidth
        >
          Resend
        </Button>
        </div>
      </Tooltip>
    );
  }

  if (user.isactivated === 0) {
    return (
      <Tooltip title={getPendingTooltip()}>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "150px" }}>

          <Button
            variant="contained"
            color="success"
            onClick={() => handleAction("approve")}
            startIcon={<CheckCircle />}
            fullWidth
          >
            Approve
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={() => handleAction("deny")}
            startIcon={<Cancel />}
            fullWidth
          >
            Deny
          </Button>

          <Button
            variant="outlined"
            color="warning"
            fullWidth
          >
            Pending
          </Button>

        </div>
      </Tooltip>
    );
  }

  if (user.isactivated === 1) {
    return (
      <Tooltip title="User currently has access">
        <div style={{width: "150px"}}>
        
        <Button
          variant="contained"
          color="error"
          startIcon={<Lock />}
          onClick={() => handleAction("deny")}
          fullWidth
        >
          Deny
        </Button>
        </div>
      </Tooltip>
    );
  }

  if (user.isactivated === 2) {
    return (
      <Tooltip title="User currently do not have access">
        <div style={{width: "150px"}}>
        
        <Button
          variant="contained"
          color="success"
          startIcon={<LockOpen />}
          onClick={() => handleAction("approve")}
          fullWidth
        >
          Approve
        </Button>
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Unknown activation status">
      <span className="badge bg-secondary">Unknown</span>
    </Tooltip>
  );
};

export default ActivationStatusCell;
